import React, { Component } from "react";
import styled from "styled-components";
import { withTenant } from "../../context/tenantConfig";

// Styled Components
const Container = styled.div`
  margin-right: 20px;
  width: 150px;
  display: flex;
  flex-direction: column;
`;

const Select = styled.select`
  padding: 7px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #fff;
  color: #333;
  outline: none;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &:hover {
    border-color: #888;
    background-color: #f7faff; /* Hover background */
  }

  &:focus {
    border-color: #006cb7;
    box-shadow: 0 0 0 2px rgba(0, 108, 183, 0.2);
    background-color: #eef6fd;
  }

  option {
    background: white;
    color: black;
  }

  option:checked {
    background: #006cb7;
    color: white;
  }
`;

class Tenant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: []
    };
  }

  handleTenant = (tenant) => {
    this.props.tenant.switchTenant(tenant);
  };

  componentDidMount() {
    const companyName = this.props.tenant.getCompanyName();
    this.setState({ options: companyName });
  }

  render() {
    return (
      <Container>
        <Select onChange={(e) => this.handleTenant(e.target.value)}>
          {this.state.options &&
            this.state.options.map((option, i) => (
              <option
                key={i}
                value={option.val}
                selected={option.active}
              >
                {option.name}
              </option>
            ))}
        </Select>
      </Container>
    );
  }
}

export default withTenant(Tenant);
